import { Modes } from '@/models/modes';
import store from '@/store/store';

export async function setGlobalMode(to) {
  switch (to.name) {
    case 'tenders-inbox':
      if (store.getters['modes/mode'] === Modes.INBOX.name) return;
      await store.dispatch('modes/setMode', { mode: Modes.INBOX });
      break;
    case 'explore':
      if (store.getters['modes/mode'] === Modes.EXPLORE.name) return;
      await store.dispatch('modes/setMode', { mode: Modes.EXPLORE });
      break;
    case 'opportunities':
    case 'opportunity-details':
    case 'opportunity-analysis':
    case 'opportunity-forms':
    case 'opportunity-form-review':
    case 'opportunity-go-nogo':
    case 'opportunity-estimation':
    case 'opportunity-quotes':
    case 'opportunity-tasks':
      if (store.getters['modes/mode'] === Modes.OPPORTUNITIES.name) return;
      await store.dispatch('modes/setMode', { mode: Modes.OPPORTUNITIES });
      break;
    case 'contact-directory':
      if (store.getters['modes/mode'] === Modes.CONTACT_DIRECTORY.name) return;
      await store.dispatch('modes/setMode', { mode: Modes.CONTACT_DIRECTORY });
      break;
    case 'business-intelligence-dashboard':
    case 'business-intelligence-competition':
      if (store.getters['modes/mode'] === Modes.BUSINESS_INTELLIGENCE.name) return;
      await store.dispatch('modes/setMode', { mode: Modes.BUSINESS_INTELLIGENCE });
      break;
    case 'tender-details':
      break;
    default:
      await store.dispatch('modes/setMode', { mode: '' });
      break;
  }
}
